import { apiSlice } from "./apiSlice";
import { apiRoutes } from "../../config/api";
import { downloadBinaryBlob } from "../../utils";

export const TagService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllTags: builder.query({
      query: (params: any) => ({
        url: apiRoutes.TAGS,
        params: params,
        method: "GET",
      }),
    }),
    getTagFilterOptions: builder.query({
      query: (params: any) => ({
        url: apiRoutes.FACTORY_TAG_FILTER_OPTIONS,
        params: params,
        method: "GET",
      }),
    }),
    getTagExportChunks: builder.mutation({
      query: (params: any) => {
        return {
          url: `${apiRoutes.EXPORT_CHUNKS_TAGS}`,
          method: "GET",
          params: params,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getTagUploadHistory: builder.query({
      query: (params: any) => {
        const { tenantId, ...queryParams } = params;
        return {
          url: `${apiRoutes.FACTORY_UPLOAD_HISTORY}/${tenantId}`,
          method: "GET",
          params: queryParams,
        };
      },
    }),

    getDiReportTag: builder.query({
      query: (params: Record<string, unknown>) => ({
        url: apiRoutes.DI_TAG,
        params: params,
        method: "GET",
      }),
    }),

    exportTrackNTraceExcel: builder.mutation<boolean, Record<string, any>>({
      async queryFn(params, _api, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: apiRoutes.TNT_EXPORT,
          method: "GET",
          params,
          responseHandler: async (response: Response) => await response.blob(),
        });

        if (result.error) {
          return { error: result.error };
        }

        const blob = result.data as Blob;

        const now = new Date();

        const formattedDate = `${String(now.getMonth() + 1).padStart(2, "0")}-${String(
          now.getDate(),
        ).padStart(2, "0")}-${now.getFullYear()}`;

        downloadBinaryBlob(blob, `enablement-summary-${formattedDate}.xlsx`);

        return { data: true };
      },
    }),

    exportDIExcel: builder.mutation<boolean, Record<string, any>>({
      async queryFn(params, _api, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: apiRoutes.DI_EXPORT,
          method: "GET",
          params,
          responseHandler: async (response: Response) => await response.blob(),
        });

        if (result.error) {
          return { error: result.error };
        }

        const blob = result.data as Blob;

        const now = new Date();

        const formattedDate = `${String(now.getMonth() + 1).padStart(2, "0")}-${String(
          now.getDate(),
        ).padStart(2, "0")}-${now.getFullYear()}`;

        downloadBinaryBlob(blob, `enablement-summary-${formattedDate}.xlsx`);

        return { data: true };
      },
    }),
  }),
});

export const {
  useGetAllTagsQuery,
  useGetTagFilterOptionsQuery,
  useGetTagUploadHistoryQuery,
  useGetTagExportChunksMutation,
  useExportTrackNTraceExcelMutation,
  useExportDIExcelMutation,
  useGetDiReportTagQuery
} = TagService;
